import * as types from "../../constants";
import { AppDispatchType } from "../store";
import {
  fetchCompany as companyFetchCompany, getCompaniesInLive,
  putCompanyInformation as putCompany,
  fetchPagedCompanies as companiesPagedFetch,
  retrieveCompanyOptions
} from "../../services/companyService";
import { DispatchOf } from "../utils";
import { CompanyActions } from "../reducers/companyReducer";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchCompany(company: string, token: string) {
  return async (dispatch: DispatchOf<CompanyActions> & DispatchOf<ErrorsActions>) => {
    return companyFetchCompany(company, token)
      .then((response) => {
        dispatch({
          type: "COMPANY_FETCH",
          company: response,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchCompanyByProperty(company: string, token: string) {
  return async (dispatch: DispatchOf<CompanyActions> & DispatchOf<ErrorsActions>) => {
    return companyFetchCompany(company, token)
      .then((response) => {
        dispatch({
          type: "COMPANY_BY_PROPERTY_FETCH",
          company: response,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function clearCompany() {
  return ({
    type: "CLEAR_COMPANY"
  })
}

export function clearCompanyByProperty() {
  return ({
    type: "CLEAR_COMPANY_BY_PROPERTY"
  })
}

export function fetchCompanyOptions(company: string, token: string){
  return async (dispatch: DispatchOf<CompanyActions> & DispatchOf<ErrorsActions>) => {

    return retrieveCompanyOptions(company, token)
      .then((response) => {
        dispatch({
          type: "COMPANYOPTIONS_FETCH",
          options: response,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function updateCompany(company: string, token: string, payload: any) {
  return async (dispatch: AppDispatchType & DispatchOf<ErrorsActions>) => {

    return putCompany(company, token, payload)
      .then((response: any) => {
        dispatch({
          type: types.COMPANY_UPDATE,
          company: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.COMPANY_ERROR,
          error: error,
        });
      });
  };
}
export function updateCompanyByProperty(company: string, token: string, payload: any) {
  return async (dispatch: AppDispatchType & DispatchOf<ErrorsActions>) => {

    return putCompany(company, token, payload)
      .then((response: any) => {
        dispatch({
          type: types.COMPANY_BY_PROPERTY_UPDATE,
          company: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.COMPANY_ERROR,
          error: error,
        });
      });
  };
}

export function clearCompanyError() {
  return (dispatch: AppDispatchType & DispatchOf<ErrorsActions>) => {
    dispatch({
      type: types.CLEAR_COMPANY_ERROR
    })
  };
}


export function fetchPagedCompanies(token: string, page: number, search: string, removeFirst: boolean = true) {
  return async (dispatch: AppDispatchType & DispatchOf<ErrorsActions>) => {
    return companiesPagedFetch(token, page, search, removeFirst).then((response) => {
      dispatch({
        type: types.FETCH_PAGED_COMPANIES,
        pagedCompanies: response.data.results
      })
      dispatch({
        type: types.SET_COMPANY_COUNT,
        count: response.data.count
      })
    })
  }
}

export function fetchCompaniesInLive(token: string, live: boolean = true, fields: string = 'id,name,is_live_user') {
  return async (dispatch: AppDispatchType & DispatchOf<ErrorsActions>) => {
    return getCompaniesInLive(token, live, fields)
      .then((response: any) => {
        let result: Array<{id: string, name: string}> = response.results
        if (result.length > 0) {
          result = result.sort((a, b) => a.name.localeCompare(b.name))
        }

        dispatch({
          type: types.FETCH_COMPANIES,
          companies: result,
        });
    }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  }
}

export function clearPagedCompanies() {
  return ({
    type: types.CLEAR_PAGED_COMPANIES,
  })
}

